<script>

  import {API_COMPANY} from '../../common/api'

  export default {
    name: 'CompanyUpdate',
    props: ['company_id'],
    data() {
      return {
        companyUpdateForm: {
          name: '',
          phone: '',
          price: '',
          tax: '',
          address: '',
          start_date: '',
          end_date: '',
        },
        rules: {
          name: [
            {required: true, message: '公司名称不能为空', trigger: 'blur'}
          ],
          phone: [
            {required: true, message: '公司电话不能为空', trigger: 'blur'}
          ],
          price: [
            {required: true, message: '水费不能为空', trigger: 'blur'}
          ],
          tax: [
            {required: true, message: '税费不能为空', trigger: 'blur'}
          ],
          start_date: [
            {required: true, message: '开始日期不能为空', trigger: 'blur'}
          ],
          end_date: [
            {required: true, message: '结束日期不能为空', trigger: 'blur'}
          ],
        }
      }
    },
    create() {
    },
    mounted() {
      this.getCompany();
    },
    methods: {
      // 员工单条
      getCompany() {
        this.isLoading = true;
        this.$http.GET(API_COMPANY + '/' + this.company_id, null,
          res => {
            this.companyUpdateForm = {
              name: res.result.data.name,
              phone: res.result.data.phone,
              price: res.result.data.price,
              tax: res.result.data.tax,
              address: res.result.data.address,
              start_date: res.result.data.start_date,
              end_date: res.result.data.end_date,
            };
            this.isLoading = false
          }, err => {
            this.$message.error(err.msg);
            this.isLoading = false
          })
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.loading = true;
            let params = this.companyUpdateForm;
            this.$http.PUT(API_COMPANY + '/' + this.company_id, params,
              res => {
                this.loading = false;
                this.$emit('updateCompanySuccess')
              }, err => {
                this.loading = false;
                this.$message.error(err.msg)
              })
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
    }
  }
</script>

<template>
  <div>
    <el-form ref="companyUpdateForm" :model="companyUpdateForm" :rules="rules" size="small" @submit.native.prevent
             label-width="100px">
      <el-form-item label="公司名称" prop="name">
        <el-input v-model="companyUpdateForm.name" placeholder="请输入公司名称" clearable class="form_input_width"></el-input>
      </el-form-item>
      <el-form-item label="公司电话" prop="phone">
        <el-input v-model="companyUpdateForm.phone" placeholder="请输入公司电话" clearable class="form_input_width"></el-input>
      </el-form-item>
      <el-form-item label="水费" prop="price">
        <el-input type="number" v-model="companyUpdateForm.price" placeholder="请输入水费" clearable
                  class="form_input_width"></el-input>
      </el-form-item>
      <el-form-item label="税费" prop="tax">
        <el-input type="number" v-model="companyUpdateForm.tax" placeholder="请输入税费" clearable
                  class="form_input_width"></el-input>
      </el-form-item>
      <el-form-item label="地址" prop="address">
        <el-input v-model="companyUpdateForm.address" placeholder="请输入地址" clearable
                  class="form_input_width"></el-input>
      </el-form-item>
      <el-form-item label="开始日期" prop="start_date">
        <el-date-picker
          v-model="companyUpdateForm.start_date"
          type="date"
          placeholder="选择开始日期" style="width: 350px;">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="结束日期" prop="end_date">
        <el-date-picker
          v-model="companyUpdateForm.end_date"
          type="date"
          placeholder="选择结束日期" style="width: 350px;">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="warning" @click="resetForm('companyUpdateForm')" size="small">重 置</el-button>
        <el-button type="primary" @click="submitForm('companyUpdateForm')" size="small">确 定</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<style lang="scss" scoped>

  @import '../../assets/styles/table.scss';

</style>



// WEBPACK FOOTER //
// src/page/company/CompanyUpdate.vue